import { css } from 'emotion';
import Constants from 'utils/Constants';

/**
 * This file defined based styles and style variables
 * to be used in styling components via emotion css-in-js.
 */

export const colorBlue = ' #194173';
export const colorLabelBlue = ' #337ab7';
export const colorLightBlue = '#BADDF5';
export const colorIconBlue = '#337ab7';
export const colorLightIconBlue = '#6cb1ec';
export const colorVeryLightBlue = '#dbecfa';
export const colorHoverBlue = '#1f477a';

export const colorBlack = '#0D1B2A';
export const colorTextBlack = '#444';
export const colorIconBlack = '#333';
export const colorCharcoal = '#2D2D2D';

export const colorButtonGreen = '#0a8b71';
export const colorGreen = '#00BD70';
export const colorDarkGreen = '#0C7048';
export const colorLightGreen = '#AAE6C4';
export const colorGreenHover = '#00DB82';

export const colorGrey = '#9E9E9E';
export const colorBorderGrey = '#ddd';
export const colorTextGrey = '#818a91';
export const colorLightGrey = '#DCDCDC';
export const colorSlateGrey = '#2f4f4f';
export const colorVeryLightGrey = '#f5f5f5';

export const colorLightOrange = '#f0ad4e';
export const colorOrange = '#dc6e00';
export const colorVeryLightYellow = '#f9f5d2';
export const colorKhaki = '#F0E68C';
export const colorRed = '#BE5959';
export const colorBrightRed = '#B40404';
export const colorPurple = '#600f84';
export const colorLightPurple = '#9d51bf';


export const baseFont = css`
    font-family: "Muli", Gadget, Arial, sans-serif;
`;

export const darkFont = css`
    font-family: "Muli", Gadget, Arial, sans-serif;
    font-weight: 700;
`;

export const mediumFont = css`
    font-family: "Muli", Gadget, Arial, sans-serif;
    font-size: 12px;
`;

export const bold = css`font-weight: bold;`;

export const getButtonStyle = (color, backgroundColor) => {
    const style = css`
        border: none;
        flex: 0 0 auto;
        padding: 5px 10px;
        border-radius: 4px;
        box-shadow: 0 10px 16px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
        ${getAnchorStyle(color, backgroundColor)}
    `;
    return style;
};


export const getAnchorStyle = (color, backgroundColor) => {
    const anchorColor = color ? color : colorLabelBlue;
    const bgColor = backgroundColor ? backgroundColor : 'transparent';
    return css`
        color: ${anchorColor} !important;
        background-color: ${bgColor} !important;
        
        &:hover {
            cursor: pointer;
            text-decoration: none;
            color: ${anchorColor} !important;
            background-color: ${bgColor} !important;

        }
        &:visited, &:focus {
            text-decoration: none;
            color: ${anchorColor} !important;
            background-color: ${bgColor} !important;
        }
    `;
};

export const getPopoverStyle = (color, backgroundColor, maxWidth) => {
    const width = maxWidth ? maxWidth : '400px';
    return css`
    .ant-popover-inner {
        max-width: ${width};
        background-color: ${backgroundColor};
        .ant-popover-inner-content {
            color: ${color};
        }
    }
    .ant-popover-arrow {
        border-right-color: ${backgroundColor} !important;
        border-bottom-color: ${backgroundColor} !important;
        border-top-color: ${backgroundColor} !important;
        border-left-color: ${backgroundColor} !important;
    }

`;
};

export const getPopoverInfoStyle = (maxWidth) => {
    return getPopoverStyle(colorTextBlack, colorVeryLightYellow, maxWidth);
};

export const popoverErrorStyle = getPopoverStyle('white', '#b34e4d');
export const popoverWarningStyle = getPopoverStyle('white', '#c09854');

export const getErrorPopoverStyle = (errorList) => {
    let popoverStyle = popoverWarningStyle;

    //if any of the errors are an error type user error style
    errorList.forEach((error) => {
        if (error.level === Constants.LEVEL_ERROR) {
            popoverStyle = popoverErrorStyle;
        }
    });
    return popoverStyle;
};




// WEBPACK FOOTER //
// ./src/styles/base.js